import { GrowthPoint, GrowthPointDto } from '../types/growth-point'

export function mapGrowthPoint(dto: Partial<GrowthPointDto>): GrowthPoint {
  return {
    content: dto?.content || '',
    id: String(dto?.id || ''),
    created: dto?.created || '',
    updated: dto?.updated || '',
    active: !!dto?.active,
    tasks: mapGrowthPointTasks(dto?.tasks || []),
  }
}

export function mapGrowthPointTasks(tasks: Partial<GrowthPointDto['tasks']>): GrowthPoint['tasks'] {
  return tasks
    ?.map((task) => {
      if (task == null) return null
      return {
        id: task?.id || '',
        exoid: task?.exoid || '',
        name: task?.name || '',
        image: task?.image || '',
        thumb: task?.thumb || '',
        status: task?.status || '',
        taskId: task?.task_id || '',
      }
    })
    .filter((task) => task != null) as GrowthPoint['tasks']
}

const mappers = {
  mapGrowthPoint,
}

export default mappers
